"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getPrettyPrintTransport() {
    return {
        target: 'pino-pretty',
        options: {
            colorize: true,
            singleLine: true,
            translateTime: 'SYS:HH:MM:ss.l'
        }
    };
}
exports.default = getPrettyPrintTransport;
//# sourceMappingURL=prettyPrintTransport.js.map